import { createEntityAdapter } from '@reduxjs/toolkit'

import { WebAdmin } from './models/WebAdmin'

export const webAdminsAdapter = createEntityAdapter({
  selectId: (webAdmin: WebAdmin) => webAdmin.id,
})